import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { api } from '@/lib/api';
import { useAuthStore } from '@/store/auth-store';
import { useVehiclesStore } from '@/store/vehicles-store';

/**
 * useVehicles: load initial vehicle list dari REST + populate vehicles store.
 * WS event subsequent akan update store secara real-time (lihat hooks/use-vehicle-sync.ts).
 *
 * staleTime 30 detik — kalau component remount dalam 30s, pakai cache.
 * Backup refetch tiap 5 menit untuk catch perubahan yang missed via WS
 * (mis. vehicle baru di-add lewat REST CRUD oleh admin lain).
 */
export function useVehicles() {
  const userId = useAuthStore((s) => s.effectiveUserId());
  const resetVehicles = useVehiclesStore((s) => s.reset);

  const query = useQuery({
    queryKey: ['vehicles', userId],
    queryFn: () => api.positions(userId!),
    enabled: !!userId,
    staleTime: 30_000,
    refetchInterval: 5 * 60_000,
  });

  // Sync hasil REST ke vehicles store untuk render real-time.
  useEffect(() => {
    if (query.data?.rows) {
      resetVehicles(query.data.rows);
    }
  }, [query.data, resetVehicles]);

  return query;
}
